// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Sticky__element--sticky{position:fixed;top:0;transform:translateY(-100%);transition:transform .5s cubic-bezier(.3,.91,.57,.89);z-index:1000}.Sticky__element--active{transform:translateY(0)}.Sticky__element--preventTransition{transition:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
